<template>
  <BaseView>
    <Security />
  </BaseView>
</template>

<script lang="ts" setup>
import BaseView from '@/views/BaseView.vue'
import Security from '@/app/views/About/Security.vue'
</script>
